import type { QueryClient } from '@tanstack/react-query';

import { supportUrlQuery } from '../../../queries/supportQuery';
export const supportLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const supportUrl = await queryClient.ensureQueryData(supportUrlQuery);

	return {
		supportUrl,
	};
};
